<template>
  <div id="app">
    <router-view />
    <b-modal
      :visible="clientVersion.unsupported || clientVersion.updateAvailable"
      :title="
        clientVersion.unsupported
          ? 'New version required'
          : 'Latest version available'
      "
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <p v-if="refreshFailed">
        Couldn't refresh automatically. Please close this tab and reopen
        TradiePass.
      </p>
      <p v-else-if="clientVersion.unsupported">
        A new version of TradiePass is required. Finish what you are doing, then
        refresh to continue.
      </p>
      <p v-else>
        A new version of TradiePass is available. Refresh to update to the
        latest version.
      </p>
      <template #modal-footer>
        <b-button variant="primary" :disabled="refreshing" @click="refresh">
          <b-spinner v-if="refreshing" small class="mr-2" />
          {{ refreshing ? 'REFRESHING...' : 'REFRESH' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import clientVersion from '@/utils/clientVersion'
import { applyUpdate } from '@/registerServiceWorker'

export default {
  data() {
    return { clientVersion, refreshing: false, refreshFailed: false }
  },
  methods: {
    refresh() {
      if (this.refreshing) return
      this.refreshing = true
      this.refreshFailed = false
      applyUpdate()
      // Outlasts applyUpdate's 8s worst case plus a slow page load, so this only fires if the reload failed
      setTimeout(() => {
        this.refreshing = false
        this.refreshFailed = true
      }, 15000)
    },
  },
}
</script>

<style lang="scss">
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
